import { render, staticRenderFns } from "./CallMatch.vue?vue&type=template&id=179cdd54&scoped=true"
import script from "./CallMatch.vue?vue&type=script&lang=js"
export * from "./CallMatch.vue?vue&type=script&lang=js"
import style0 from "./CallMatch.vue?vue&type=style&index=0&id=179cdd54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179cdd54",
  null
  
)

export default component.exports